<mat-dialog-content>
  <div class="d-flex flex-column align-items-center">
    <img
      src="assets/images/warning_icon.svg"
      alt="error"
      class="mb-3"
      width="50px"
      height="73px"
    />
    <p class="color-dark fw-500 text-center">
      {{ errorMsg || "We're sorry, but an unexpected error has occurred." }}
    </p>
    <div>
      <button class="btn btn-primary" (click)="errorDialogRef.close()">
        Close
      </button>
    </div>
  </div>
</mat-dialog-content>
